import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-dinela',
  templateUrl: './dinela.component.html',
  styleUrls: ['./dinela.component.scss']
})
export class DinelaComponent implements OnInit {

  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['dinela'];
  }

}
